import React, { useEffect, useState } from "react";
import axios from "axios";
import { variables } from "./Variables.js";
import TrendingNewsMain from "./TrendingNewsMain.js";

export default function TrendingNews() {
  const jsonUrl =
    variables.basename_url +
    "updates/index/Athlethixnet_HomeEn_TrendingNews.json";

  // const jsonUrl = "/Data/Athlethixnet_HomeEn_TrendingNews.json";


  const [isLoading, setIsLoading] = useState(true);
  const [trendingData, setTrendingData] = useState([]);

  useEffect(() => {
    const fetchTrendingNews = async () => {
      try {
        setIsLoading(true);

        document.getElementById("English_Header").hidden = false;
        document.getElementById("English_Footer").hidden = false;

        const response = await axios.get(jsonUrl);
        const data = response.data || [];

        const formattedData = data
          .slice(1, 6)
          .map((item) => ({
            news_industryIDs: item.news_industryIDs,
            Image: item.Image,
            Title: item.Title,
            Description: item.Description
              ?.replace("https://menafn.com/", variables.domain_name + "/")
              .replace("https://menafn.com", variables.domain_name)
              .replace(/MENAFN/g, variables.domain),
            link: item.link,
            news_date: item.news_date?.split(" ")[0],
            Category: item.Category,
          }));

        setTrendingData(formattedData);
      } catch (error) {
        console.error("Error fetching trending news:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTrendingNews();
  }, [jsonUrl]);

  return (
    <div className="container custom-container bg-white">
      <div className="video-style-box mt-2">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title">
              <a href="Tennis_Ar">
                <h3 className="title mt-4 mr-4 mb-1">Trending News</h3>
              </a>
            </div>
          </div>
        </div>

        <div className="row">
          <TrendingNewsMain />

          <div className="col-lg-6">
            {isLoading ? (
              <p>Loading...</p>
            ) : (
              trendingData.map((da) => (
                <div key={da.Title}>
                  <div className="video-play-sidebar-items">
                    <div className="post-gallery-style-2">
                      <div className="post-gallery-thumb">
                        <a href={da.link}>
                          <img
                            className="rounded"
                            style={{
                              maxWidth: "100px",
                              maxHeight: "70px",
                              minWidth: "100px",
                              minHeight: "70px",
                            }}
                            src={da.Image}
                            alt={da.Title}
                          />
                        </a>
                      </div>

                      <div className="post-gallery-content col-sm-8">
                        <h5 className="title">
                          <a href={da.link} tabIndex={-1}>
                            {da.Title}
                          </a>
                        </h5>

                        <div className="meta-post-2-style">
                          <div className="meta-post-categores">
                            <a href={da.link} tabIndex={-1}>
                              {da.Category}
                            </a>
                          </div>
                          <div className="meta-post-date">
                            <span>{da.news_date}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
